import TextField from '@mui/material/TextField';

const FromTextField = ({
  helperText = "",
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfTorihikisakicd"
    label="取引先コード"
    size="small"
    inputProps={{ maxLength: 7 }}
    onChange={(event: any) => { onChange(event); }}
    error={!!helperText}
    helperText={helperText}
  />
);

export default FromTextField;